import { useEffect } from "react";
import HeroAbout from "../../../components/pages/coach/aboutus/HeroAbout";
import OurMission from "../../../components/pages/coach/aboutus/OurMission";
import OurStory from "../../../components/pages/coach/aboutus/OurStory";
import Offer from "../../../components/pages/coach/aboutus/Offer";
import People from "../../../components/pages/coach/aboutus/People";
import Build from "../../../components/pages/coach/aboutus/Build";
import MenuLayout from "../../../layouts/MenuLayout";
import BootCampLayout from "../../../layouts/BootCampLayout";
import { useLocation } from "react-router-dom";

const AboutUs = () => {
  const user = { name: "About Us", role: "coach" };
  const { state } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      {state?.data === "landing" ? (
        <MenuLayout user={user}>
          <HeroAbout />
          <OurStory />
          <OurMission />
          <Offer />
          <People />
          <Build />
        </MenuLayout>
      ) : (
        <BootCampLayout user={user}>
          <HeroAbout />
          <OurStory />
          <OurMission />
          <Offer />
          <People />
          <Build />
        </BootCampLayout>
      )}
    </>
  );
};

export default AboutUs;